export enum AppointmentEntityType {
  HOSPITAL = "hospital",
  SPECIALIST = "specialist",
}
